import type { Language } from '@seek/melways-sites';

export enum SelectAllStatus {
  SelectAll = 'select-all',
  SelectAllIndividually = 'select-all-individually',
  PartialSelect = 'partial-select',
  NonSelected = 'non-selected',
  Empty = 'empty',
  SelectAllInFolder = 'select-all-in-folder',
}

export type Bucket =
  | 'INBOX'
  | 'PRESCREEN'
  | 'SHORTLIST'
  | 'INTERVIEW'
  | 'OFFER'
  | 'ACCEPT'
  | 'NOT_SUITABLE'
  | '';

export type LowerCaseBucketName =
  | 'inbox'
  | 'prescreen'
  | 'shortlist'
  | 'interview'
  | 'offer'
  | 'accept'
  | 'not_suitable'
  | '';

export enum BUCKETS {
  INBOX = 'INBOX',
  PRESCREEN = 'PRESCREEN',
  SHORTLIST = 'SHORTLIST',
  INTERVIEW = 'INTERVIEW',
  OFFER = 'OFFER',
  ACCEPT = 'ACCEPT',
  NOT_SUITABLE = 'NOT_SUITABLE',
  UNKNOWN = '',
}

export enum FilterOperator {
  AND = 'AND',
  OR = 'OR',
}

export interface RoleRequirementFilter {
  operator: FilterOperator;
  questionId: string;
  answerIds: string[];
}

export interface SearchFilters {
  rrGlobalFilters: RoleRequirementFilter[];
  homeLocationIds?: string[];
  nationalityRightToWorkIds?: string[];
}

export interface HomeLocationDescriptionInput {
  language: Language;
  displayCountry: string;
}

export interface RightToWorkDisplayLabelInput {
  language: Language;
}

export interface NationalityLabelInput {
  language: Language;
}
